import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModuloService } from 'src/app/modulo/modulo.service';
import { AplicacionesService } from 'src/app/aplicaciones/aplicaciones.service';
import { AccionesService } from '../acciones.service';

@Component({
  selector: 'app-editar-accion',
  templateUrl: './editar-accion.component.html',
  styleUrls: ['./editar-accion.component.scss']
})
export class EditarAccionComponent implements OnInit {

  accion_form : FormGroup;
  modulos = []

  constructor(private fb : FormBuilder,
              private mod_serv : ModuloService, 
              private app_serv : AplicacionesService,
              private acc_serv : AccionesService
              ) { }

  ngOnInit(): void {
    this.accion_form = this.fb.group({
      fk_modulo: [null],
      descripcion: [null, Validators.required],
      ruta: [null],
      ind_estado :[true]
    });

    this.modulos = this.mod_serv.modulos;
    this.rellenar_forma();
  }

  onSubmit(){

    let data_form = this.crear_item_accion();
    this.acc_serv.gestionar_accion(data_form);


  }

  /**
   * Crea el item con lo datos para la accion a registrar.
   */
  crear_item_accion(){
    let item = {
      'app' : this.app_serv.get_aplicacion().id_aplicacion
    };

    let json_accion ={
      "txt_descripcion": this.accion_form.get('descripcion').value,
      "txt_ruta": this.accion_form.get('ruta').value,
      "fk_modulo": this.accion_form.get('fk_modulo').value

    };

    if(this.acc_serv.id_accion){
      json_accion['id_accion'] = this.acc_serv.id_accion;
    }

    item ['acciones'] = [json_accion]

    return item;
  }

  rellenar_forma(){

    if (this.acc_serv.id_accion){
      this.acc_serv
          .consultar_accion(this.acc_serv.id_accion)
          .then(
            () =>{
              let datos_accion = this.acc_serv.datos_accion;

              this.accion_form.get('descripcion').setValue(datos_accion.descripcion);
              this.accion_form.get('ruta').setValue(datos_accion.ruta);
              this.accion_form.get('fk_modulo').setValue(datos_accion.fk_modulo);
              this.accion_form.get('ind_estado').setValue(datos_accion.ind_estado);

            }
          );
    }

  }

}
